import styles from './agreementCard.module.scss';

export interface ProductQuantityInfoProps {
  total: number;
  available: number;
  peopleLength?: number;
}

export function getLowQuantityThreshold(total: number): number {
  if (total <= 5) return 0.8;
  if (total <= 10) return 0.6;
  if (total <= 20) return 0.5;
  if (total <= 50) return 0.35;
  if (total <= 150) return 0.2;
  if (total <= 500) return 0.1;
  return 0.05;
}

export default function ProductQuantityInfo({
  total,
  available,
  peopleLength = undefined,
}: ProductQuantityInfoProps) {
  if (
    available === 0 ||
    available < 0 ||
    (peopleLength && peopleLength > available)
  ) {
    return <p className={styles.notAvailable}> No quantity available</p>;
  }

  const threshold = getLowQuantityThreshold(total);
  const isLowQuantity = available / total <= threshold;

  if (isLowQuantity) {
    return <p className={styles.lowAvailable}> Low quantity available</p>;
  }

  return null;
}
